// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1mbcC","signatureButtonsRight":"ModalSign_signatureButtonsRight__1hB_9"};